import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import iso9001 from 'assets/img/logos/9001.png';
import iso270001 from 'assets/img/logos/27001.png';
import Avatar from 'components/common/Avatar';
import user1 from 'assets/img/team/1.jpg';
import { Nav, Dropdown } from 'react-bootstrap';
import AppContext from 'context/Context';
import { useAuth } from 'context/AuthWizardContext';

const LandingRightSideNavItem = () => {
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const { logout, user } = useAuth();
  const {
    config: { isDark, isRTL },
    setConfig
  } = useContext(AppContext);

  return (
    <Nav navbar className="ms-auto">
      <Dropdown className='mt-1 mx-2'>
        <Dropdown.Toggle as={Link} to="#!" className="nav-link fw-bold">
          <Avatar
            src={user.ppURL}
            rounded="circle"
            size="xl"
          />
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-end dropdown-menu-card mt-0 dropdown-caret dropdown-caret-bg">
        <Dropdown.Item as={Link} to="/user/settings">
            Profile
          </Dropdown.Item>
          <Dropdown.Item as={Link} to ='/user/settings/change-password'>
            Change Password
          </Dropdown.Item>
          <Dropdown.Item as={Link} onClick={logout}>
            Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </Nav>
  );
};

export default LandingRightSideNavItem;
